module.exports = __webpack_public_path__ + "static/media/interactive_coding.175d1298.pdf";